import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import auth from '../../services/authentication';
import {signOut} from '../../store/searchAction';
import {useHistory} from 'react-router-dom';
import {ReactComponent as AvatarIcon} from '../../../images/avatar-icon.svg';
import OutsideAlerter from '../../hooks/OutsideAlerter';
import * as Styled from './AvatarStyles';

export interface AvatarStandardProps {
  largeImg?: string;
  hasDrop?: boolean;
}

const Avatar = React.memo(({largeImg, hasDrop}:AvatarStandardProps) => {
  const [isSignOutVisible, setSignOutVisible] = useState(false);
  const [initials, setInitials] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const HandleSignOut = () => {
    history.push('/');
    dispatch(signOut());
  }

  const avatarClick = () => {
    if (!auth.isAuthenticated()) {
      history.push('/signin-beta');
      return;
    }
    if (hasDrop) {
      setSignOutVisible(currValue => !currValue);
    }
  }

  useEffect(() => {
    const userName = auth.getUserName();
    const email = auth.getEmail();

    if (userName) {
      const splitName = userName.split(' ');
      let initials = splitName[0].charAt(0).toUpperCase();
      if (splitName[1]) {
        initials = `${initials}${splitName[1].charAt(0).toUpperCase()}`
      }
      setInitials(initials);
    } else if (email) {
      setInitials(email.slice(0, 2).toUpperCase());
    }
  }, []);

  return (
    <OutsideAlerter setFunction={setSignOutVisible}>
      <Styled.Container className='Wrapper'>
        {      
          (auth.isAuthenticated() && initials) ?
            <Styled.StyledInitials className={`AvatarText ${largeImg || ''}`}
              onClick={avatarClick}
            >
              {initials}
            </Styled.StyledInitials>
            :
            <AvatarIcon
              height={largeImg ? 100 : 34}
              width={largeImg ? 100 : 34}
              fill={'#2C2B48'}
              onClick={avatarClick}
            />
        }
        {
          isSignOutVisible &&
            <Styled.Container className='HidenSignOut'>
              <Styled.ListItem>
                <Styled.DropItem onClick={HandleSignOut}>Sign Out</Styled.DropItem>
              </Styled.ListItem>
              <Styled.ListItem>
                <Styled.DropLink to="/privacy">Privacy & Terms</Styled.DropLink>
              </Styled.ListItem>

            </Styled.Container>
        }
      </Styled.Container>
    </OutsideAlerter>
  );
})

export default Avatar;